import type { SexualHealthState } from "./SexualHealthContext";
import { isHeterosexualConceptionContext } from "./sexualHealthApplicability";

export type SexualHealthFlowRoute =
  | "PapSmear"
  | "PapSmearProcedures"
  | "PapSmearProcedureDetails"
  | "STDs"
  | "STDDetails"
  | "VaginalInfections"
  | "VaginalInfectionDetails"
  | "PainfulIntercourse"
  | "Lubricants"
  | "PartnerEjaculate"
  | "ErectileDifficulties"
  | "SexualHealthComplete";

export function buildSexualHealthNavigationStack(
  state: SexualHealthState,
): SexualHealthFlowRoute[] {
  const isMale = state.userGender === "male";
  const isHeterosexualConception = isHeterosexualConceptionContext(state);
  const stack: SexualHealthFlowRoute[] = [];

  // Pap smear & follow-ups — AFAB-only (cervical screening)
  if (!isMale) {
    stack.push("PapSmear");
    if (state.hadPapSmear === true && state.papSmearResultAbnormal === true) {
      stack.push("PapSmearProcedures");
      if (
        state.hadPapSmearProcedures === true &&
        state.papSmearProcedures.length > 0
      ) {
        stack.push("PapSmearProcedureDetails");
      }
    }
  }

  // STDs — co-ed
  stack.push("STDs");
  if (state.hadSTDs === true && state.stds.length > 0) {
    stack.push("STDDetails");
  }

  // Vaginal infections — AFAB-only
  if (!isMale) {
    stack.push("VaginalInfections");
    if (state.hasVaginalInfectionHistory === true) {
      stack.push("VaginalInfectionDetails");
    }
  }

  // Co-ed remaining
  stack.push("PainfulIntercourse");
  if (isHeterosexualConception) {
    stack.push("Lubricants");
  }
  // PartnerEjaculate wording changes by patient sex, but the data point is
  // relevant to either partner in an opposite-sex conception pathway.
  if (isHeterosexualConception) {
    stack.push("PartnerEjaculate");
  }
  // Erectile difficulties — AMAB-only
  if (isMale) {
    stack.push("ErectileDifficulties");
  }
  stack.push("SexualHealthComplete");

  return stack;
}
